import styled from 'styled-components';

export const LanguagesDrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.162) 17%, rgba(255, 194, 41, 0.159) 100%), #FFFFFF;
  padding: 32px;

  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 64px;
  }
`;

export const LanguagesDrawerTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const LanguagesDrawerTitle = styled.h3`
  font-weight: 300;
  font-size: 32px;
  line-height: 42px;
  color: #171C33;
`;

export const LanguagesDrawerDescription = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  color: #171C33;
`;

export const LanguagesDrawerListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  & > :not(:last-child) {
    margin-bottom: 8px;
  }
  overflow-y: auto;
`;

export const LanguageDrawerListItem = styled.span`
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: #171C33;
`;